import React from "react";

// state: idle | listening | thinking | speaking
export default function Orb({ state = "idle", size = 180 }) {
  return (
    <div className="orb-wrap" data-testid="archon-orb" data-state={state}>
      <div
        className={`orb ${state}`}
        style={{ width: size, height: size }}
      />
    </div>
  );
}
